function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <footer style={{
            minHeight: '15vh',
        }}>
            <div style={{ width: '100%', textAlign: 'center' }}>
                <div style={{ minHeight: '10vh' }}></div>
                <p className="footer__text">© {currentYear} Medigap Vision</p>
            </div>
        </footer>
    );
}

export default Footer;
